module.exports = __webpack_public_path__ + "static/media/comuu2.f3e1f789.jpg";